module.exports = {
  "id": "lock",
  "title": "lock",
  "image": "provision/parts/lock/lock.png",
  "info": [
    {
      "text": "Add a lock to your project",
      "image": "provision/parts/lock/lock.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/lock/lock.png"
} ;